<template>
  <div id="selectDate">
    <div class="wrapper">
      <div class="heading">
        <h1>Select your slots</h1>
        <div class="cart">
          <button @click="openResume=true">
            <SvgCart /> <span>Your cart ({{selectedDates.length}})</span>
          </button>
        </div>
      </div>
      <div class="step-select" v-if="!submitLoading">
        <div class="semaine">
          <div class="semaine-select">
            <ul class="navigator">
              <li @click="$refs.calendar.prev()" class="arrow arrow-prev">
                <img src="/images/arrow-left.png" />
              </li>
              <li class="semaine-item">From {{startWeek}} to {{endWeek}}<li>
              <li @click="$refs.calendar.next()" class="arrow arrow-next"> 
                <img src="/images/arrow-right.png" />
              </li>
            </ul>
            <div class="slider-container">
              <v-sheet height="600">
                <v-calendar
                    ref="calendar"
                    v-model="focus"
                    :weekdays="[1, 2, 3, 4, 5, 6, 0]"
                    type="week"
                    :events="events"
                    :event-color="getEventColor"
                    @change="getEvents"
                    @click:event="addDate"
                >
                  <template #event="{ event }">
                    <div
                        class="v-event-draggable pa-1"
                    >
                      <div>{{displayHour(event)}}</div>
                      <div><strong>Bays: #{{event.bays}}</strong></div>
                    </div>
                  </template>
                </v-calendar>
              </v-sheet>
            </div>
          </div>
        </div>
        <div :class="['resume',openResume?'open':null]">
          <div class="inner">
            <div class="close" @click="openResume=false">
              <SvgRemove />
            </div>
            <div class="heading">
              <h2>Résume</h2>
              <span v-if="credit" style="margin-right:20px;">You have {{credit}} free hours</span>
            </div>
            
            <ul>
              <li v-for="event in selectedDates" :key="event.id">  
                <div class="item"  @click="removeDate(event)">
                  <SvgRemove /> <span>{{ displayDay(event) }}</span>
                </div>
              </li>
            </ul>  
            <div class="resume-footer">
              <div class="price">{{total}} CHF</div>
              <button class="btn primary" @click="submit()" :disabled="!selectedDates.length">Validate</button>
            </div>
          </div>
        </div>
      </div>
      <div v-else >
          Loading
      </div>
    </div>
  </div>
</template>

<script>
import SvgCart from "@/components/SvgCart.vue"
import SvgRemove from "@/components/SvgRemove.vue"
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
/*import fr from 'moment/locale/fr'
moment.updateLocale('fr', fr)*/

export default {
  middleware: ['redirect-invoice'],
  components:{
    SvgRemove,
    SvgCart
  },
  data: () => ({
    submitLoading:false,
    loading:false,
    now:null,
    startWeek:null,
    endWeek:null,
    selectedDates: [],
    focus:'',
    openResume:false
  }),
 computed: {
   ...mapGetters("scheduler", ["events", "openReservations"]),
   ...mapGetters("auth", ["hasOpenInvoice","price","credit"]),
    availableEvents(){
      return this.events.filter(ev => ev.type!=='reserved' )
    },
    total(){
      if(this.credit){
        return (this.credit>=this.selectedDates.length)?0:this.price*(this.selectedDates.length-this.credit)
      }else{
        return this.price*this.selectedDates.length;
      }
    }
  },
  watch:{
    /*hasOpenInvoice(newval){
      if(newval)
        this.$router.push("paid")
    },*/
    hasnotPackage(newval){
      if(newval)
        this.$router.push("package")
    }
  },
  mounted(){
    this.now = moment()
    this.calculateWeek()
    this.loadAvailableSlot()
    this.fillCartWithOpenReservations()
  },
  methods: {
    ...mapActions("scheduler", {getAvailableSlot:"list", makeReservation:"createReservation"}),
    addDate: function(event) {
      let e = this.events.find(ev => ev.id==event.event.id)
      if(e.selected!=true){
        e.selected = true
        this.selectedDates.push(e)
      }
      this.openResume=true
    },
    removeDate: function(dates) {
      dates.selected = false
      let idx = this.selectedDates.findIndex(ev => ev.start == dates.start)
      this.selectedDates.splice(idx,1)
    },
    loadAvailableSlot() {
      this.loading=true;
      this.getAvailableSlot(this.now.format("YYYY-MM-DD"))
      .finally(() => {
        this.loading=false
        this.markAsSelected()
      })
    },
    markAsSelected(){
      for (let idx = 0; idx < this.events.length; idx++) {
        const event = this.events[idx];
        for (let idxReserved = 0; idxReserved < this.selectedDates.length; idxReserved++) {
          const date = this.selectedDates[idxReserved];
          if(event.start == date.start){
            event.selected=true
          }
        }
      }
    },
    nextWeek: function() { 
      this.now.add(7, 'days')
      this.calculateWeek()
      this.loadAvailableSlot()
    },
    prevWeek: function() {
      this.now.subtract(7, 'days')
      this.calculateWeek()
      this.loadAvailableSlot()
    },

    getEvents(e){
      if(e){
        this.startDate = e.start.date;
      }else if(!this.startDate){
        this.startDate= moment().format("YYYY-MM-DD");
      }
      this.calculateWeek()

      this.getAvailableSlot(this.startDate)
    },
    
    calculateWeek(){
      this.startWeek= moment(this.startDate).startOf('isoWeek').format("YYYY-MM-DD");
      this.endWeek = moment(this.startDate).endOf('isoWeek').format("YYYY-MM-DD");
    },

    displayDay(day){
      return moment(day.start).format("dddd DD MMMM")+ " - " + moment(day.start).format("HH:mm") + " to " + moment(day.end).format("HH:mm")
    },
    submit(){
      this.submitLoading=true
      const reservations = []
      for (let idx = 0; idx < this.selectedDates.length; idx++) {
        const date = this.selectedDates[idx];

        if(!this.selectedDates.id){
          reservations.push({
            'date' : moment(date.start).format("YYYY-MM-DD"),
            'start_hour':  moment(date.start).format("HH:mm"),
            'end_hour': moment(date.end).format("HH:mm"),
            'bays':date.bays,
            'client_id':this.$store.getters["auth/currentUser"].id
          }) 
        }
      }
      this.makeReservation(reservations).then(() => {
        this.$router.push("/agenda/confirmdate")
/*        if(data.status =='toPaid'){
          this.$router.push("/agenda/paid")
        }else if(data.status =='confirmation'){
        }*/
      }).finally(() => {
        this.submitLoading=false
      })
    },
    fillCartWithOpenReservations(){
      if(this.openReservations){
        this.openReservations.forEach(reservation => {
          this.selectedDates.push({
            start : moment(reservation.date+ " " +reservation.start_hour),
            end : moment(reservation.date+ " " +reservation.end_hour),
            bays : reservation.bays,
            id: reservation.id
          })
        });
      }
    },
    
    displayHour(event){
      return moment(event.start).format("HH:mm") + " - " + moment(event.end).format("HH:mm")
    },
    showEvent(){},
    getEventColor (event) {
      return (event.selected==true)?'selected':event.color
    },
  }
}
</script>

<style lang="less">
  .blue.lighten-1,
  .teal.lighten-2 {
    background-color:#c9af6b;
  }

  .selected{
    background-color:#000000;
    color:#c9af6b;
  }

  .theme--light.v-calendar-events .v-event-timed{
    border-color:#977317 !important;
  }
  #selectDate{
    min-height: calc(100vh - 400px);
    width: 100%;
    background-color: #fff;
    .heading{
      display:flex;
      justify-content: space-between;
      h1{
        font-size: 24px;
        color: #2F2B2B;
        margin-bottom: 50px;
        font-weight: 800;
      }
    }
    .step-select{
      justify-content: space-between;
      @media (max-width: 980px) { 
        flex-direction: column;
       }
      .semaine{
        position: relative;
        flex: 0 0 60%;
        @media (max-width: 750px) { 
          margin-right: 0;
          width: 100%;
        }
        .semaine-select{
          .navigator { 
            text-align: center; 
            display: flex; 
            justify-content: space-between;
            overflow: hidden; 
            margin-bottom: 50px;
            flex-wrap: wrap;
            width: 100%;
            align-items: center;
            li { 
              &.arrow{
                cursor: pointer;
                transition: all .32s ease;
                position: relative;
                transform: translateY(-2px);
                width: 30px;
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
              }
              &.semaine-item{
                background-color: #F6F6F6;
                text-align: center;
                width: calc(100%  - 150px);
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 10px;
              }
            }            
          }
        }
        .slider-container { 
          overflow: hidden; 
          width: 100%;
          .slider { 
            width: 2800px; 
            overflow: hidden; 
            transition: all .32s ease; 
            .slide { 
              float: left; 
              width: 700px; 
              ul{
                li{
                  .item{
                    margin-bottom: 20px;
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    svg{
                      margin-right: 20px;
                    }
                  }
                  .isSelected{
                    opacity: .3;
                    pointer-events: none;
                  }

                }
              }
            }
          }
        }
      }
      .resume{
        overflow: hidden;
        width: 0%;
        position: absolute;
        top:0;
        right: 0;
        height: 100vh;
        background-color: #F6F6F6;
        transition: .3s all ease-in;
        &.open{
          width: 40%;
        }
        .inner{
          padding: 50px;
        }
        .close{
          position: absolute;
          top:20px;
          left:20px;
        }
        h2{
          font-size: 18px;
          color: #2F2B2B;
          margin-bottom: 50px;
          font-weight: 800;
        }
        ul{
          li{
            .item{
              margin-bottom: 20px;
              display: flex;
              align-items: center;
              cursor: pointer;
              svg{
                margin-right: 20px;
              }
            }
          }
        }
        .resume-footer{
          display: flex;
          align-items: center;
          justify-content: space-between;
          .price{
            font-size: 24px;
            color: #2F2B2B;   
            font-weight: 900;        
          }
        }
      }
    }
  }
  .cart{
    display: flex;
    justify-content: center;
    align-items: center;
    button{
      background: #c9af6b;
      color:#000000;
      padding: 10px;
      display: flex;
      align-items: center;
      svg{
        margin-right: 10px;
      }
    }
  }
</style>